<div class="alert alert-secondary mt-3 mx-2" role="alert">
    <strong>KPO OBRAZAC:</strong> Knjiga o ostvarenom prometu ili KPO knjiga je obrazac koji moraju da popunjavaju svi paušalno oporezovani preduzetnici. Njome su hronološki obuhvaćeni svi prihodi koje je preduzetnik paušalac ostvario od prodaje proizvoda ili usluga u toku jedne kalendarske godine.  
  </div>
  <div class="alert alert-info mt-3 mx-2" role="alert">
    <strong>UPUTSTVO:</strong> Molimo vas da unesete godinu za koju želite da generišete KPO izveštaj. 
    Godina mora biti 2020 ili novija. Nakon unosa, kliknite na dugme <em>Štampaj izveštaj</em> kako biste preuzeli PDF dokument.Ukoliko želite prikaz <em>KPO zaglavlja</em> molimo vas pod opcijom <em>Zaglavlje izveštaja</em> odaberete opciju <em>Bez</em>.
  </div>

<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">

    <div class="form-group row">
        <div class="col-md-4">
            <yt-input [Type]="'text'" [Label]="'KPOOBRAZAC.GODINA.SINGULAR'" formControlName="Godina"
                [ngClass]="{ 'is-invalid': submitted && fc.Godina.invalid }" [MaxLength]="4">
            </yt-input>
            <div class="form-error" *ngIf="submitted && fc.Godina.invalid">
                <span *ngFor="let validation of errorMessages.Godina">
                    <span class="error-message" *ngIf="fc.Godina.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
    </div>
    
    <div class="form-group row">
        <div class="col-md-12">
            <button type="button" class="btn btn-primary" (click)="LoadPDF()">Štampaj izveštaj</button>
        </div>
    </div>
</form>